import { createSelector } from 'reselect';
import { get } from 'stash/utils';

export const selectSignUpState = (state) => {
	return {
		application: state.application,
		entities: state.entities,
	};
};

export const selectSignUpFirstPurchase = (state) => {
	return get(state, 'application.signUp.firstPurchase', {});
};

export const screensWithoutPurchaseOrder = {
	'/sign-up/account-options': true,
	'/sign-up/introduction': true,
	'/sign-up/financial-profile': true,
	'/sign-up/verify-identity': true,
	'/sign-up/stash-plan': true,
	'/sign-up/invest-summary': true,
	'/sign-up/referral': true,
	'/sign-up/billing-frequency': true,

	'/sign-up-purchase/get-started': true,
	'/sign-up-purchase/account-options': true,
	'/sign-up-purchase/introduction': true,
	'/sign-up-purchase/financial-profile': true,
	'/sign-up-purchase/verify-identity': true,
	'/sign-up-purchase/stash-plan': true,
	'/sign-up-purchase/invest-summary': true,
	'/sign-up-purchase/referral': true,
};

export const selectHasPurchaseOrder = createSelector(
	selectSignUpFirstPurchase,
	(_, props) => get(props, 'location.pathname'),
	(firstPurchase, pathname) => {
		return !!(
			firstPurchase.ticker &&
			firstPurchase.amount &&
			firstPurchase.card_id &&
			!get(screensWithoutPurchaseOrder, pathname, false)
		);
	}
);
